import React from "react";

class Footer extends React.Component {
  render() {
    return <footer className="m-t-15" />;
  }
}
export default Footer;
